import request from '@/utils/request'

export function listShopOrderRemindStaff(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopOrderRemind.listShopOrderRemindStaff',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export function saveShopOrderRemindStaff(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopOrderRemind.saveShopOrderRemindStaff',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}
